module.exports = __webpack_public_path__ + "img/IR_DAB_-_FAAS_Helena_Funding_Press_Release.17da11dd.png";